<template>
  <div :class="['add-node-btn-box',isDisabled]">
    <div class="add-node-btn">
      <button v-show="hasBtn" class="btn" type="button" @click="$emit('onAddNode')">
        <span class="el-icon-plus add-icon"/>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddNode',
  props: {
    hasBtn: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.add-node-btn-box {
    width: 200px;
    display: inline-flex;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    position: relative;

    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 2px;
        height: 100%;
        background-color: #D8D8D8;
    }

    .add-node-btn {
        user-select: none;
        width: 200px;
        padding: 24px 0;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        flex-shrink: 0;
        -webkit-box-flex: 1;
        flex-grow: 1;
        cursor: pointer;
        .btn {
            outline: none;
            width: 32px;
            height: 32px;
            background: #2E7EFF;
            border-radius: 50%;
            position: relative;
            border: none;
            line-height: 32px;
            transition: all .3s cubic-bezier(.645, .045, .355, 1);
            cursor: pointer;

            .add-icon {
              color: #fff;
              font-size: 16px;
              font-weight: bold;
            }
            &:hover {
              transform: scale(1.25);
              box-shadow: 0px 2px 8px 0px #2E7EFF;
            }
        }
    }
}
</style>
